import * as React from 'react';

import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import PortalNotice from '../../containers/PortalNotice';
import i18n from '../../resources/i18n';
/**
 * お知らせ画面
 * @param props
 */
const Portal: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('Portal_0001')} />
			<PortalNotice />
		</>
	);
};

export default Portal;



// WEBPACK FOOTER //
// ./src/pages/personal/Portal.tsx